import React from 'react'
import { logSessionInfo } from '../../../../../services/logger'
import './AdditionalDetailsView.scss'

export default function AdditionalDetailsView(props) {
  const { onClickYes, onClickNo } = props

  const flagStudent = (hasTroubleUnderstanding) => {
    // Log the appropriate flag event
    if (hasTroubleUnderstanding) {
      logSessionInfo('teacherTroubleshoot_FLAG_HARD_TO_UNDERSTAND', {})
    } else {
      logSessionInfo('teacherTroubleshoot_SKIP_FLAG_HARD_TO_UNDERSTAND', {})
    }
  }

  const handleYesClick = () => {
    flagStudent(true)
    onClickYes()
  }

  const handleNoClick = () => {
    flagStudent(false)
    onClickNo()
  }

  return (
    <div className="additional-details-view">
      <div className="additional-details-view__content">
        <div className="additional-details-view__header">
          <svg 
            className="additional-details-view__header-icon"
            xmlns="http://www.w3.org/2000/svg" 
            width="60" 
            height="60" 
            viewBox="0 0 41 40" 
            fill="none"
          >
            <rect x="0.5" width="40" height="40" rx="20" fill="white"/>
            <circle cx="20.5" cy="20" r="20" fill="#3E83BE"/>
            <path d="M28.1467 15.4049C28.1467 13.0968 27.2789 11.287 25.878 10.0615C24.5129 8.86682 22.7439 8.31157 21.0225 8.24246C17.7247 8.11004 13.7239 9.82514 12.8867 13.6602C12.8461 13.8463 12.8416 14.0387 12.8736 14.2266C12.9056 14.4145 12.9733 14.594 13.073 14.755C13.1726 14.9161 13.3022 15.0554 13.4544 15.165C13.6065 15.2747 13.7783 15.3525 13.9598 15.3941C14.1413 15.4358 14.329 15.4403 14.5122 15.4075C14.6954 15.3747 14.8706 15.3053 15.0276 15.2031C15.1846 15.1009 15.3205 14.968 15.4274 14.812C15.5344 14.656 15.6103 14.4799 15.6509 14.2938C16.0599 12.4178 18.2905 11.039 20.9115 11.1441C22.1497 11.1941 23.2622 11.5908 24.0394 12.2709C24.7803 12.9185 25.3144 13.9058 25.3144 15.4049C25.3144 16.8854 24.5939 17.8594 23.5426 18.547C22.4403 19.2684 21.057 19.6 20.1179 19.6674C19.7602 19.693 19.4254 19.8567 19.1808 20.1255C18.9363 20.3944 18.8003 20.7483 18.8003 21.1159V23.6261C18.8003 24.0112 18.9495 24.3805 19.2151 24.6528C19.4807 24.9251 19.8409 25.0781 20.2164 25.0781C20.592 25.0781 20.9522 24.9251 21.2178 24.6528C21.4834 24.3805 21.6326 24.0112 21.6326 23.6261V22.3768C22.7145 22.1515 23.9561 21.7217 25.0663 20.9957C26.7181 19.9148 28.1467 18.1126 28.1467 15.4049ZM20.4997 26.5301C19.8987 26.5301 19.3224 26.7749 18.8975 27.2106C18.4726 27.6463 18.2339 28.2372 18.2339 28.8533C18.2339 29.4695 18.4726 30.0604 18.8975 30.4961C19.3224 30.9318 19.8987 31.1765 20.4997 31.1765C21.1006 31.1765 21.6769 30.9318 22.1018 30.4961C22.5267 30.0604 22.7654 29.4695 22.7654 28.8533C22.7654 28.2372 22.5267 27.6463 22.1018 27.2106C21.6769 26.7749 21.1006 26.5301 20.4997 26.5301Z" fill="white"/>
          </svg>
          <div className="additional-details-view__title">
            ADDITIONAL DETAILS
          </div>
        </div>
        
        <div className="additional-details-view__question">
          Do you have trouble understanding this student's speech?
        </div>
      </div>
      
      <div className="additional-details-view__button-container">
        <button 
          className="additional-details-view__button"
          onClick={handleYesClick}
        >
          Yes
        </button>
        <button 
          className="additional-details-view__button"
          onClick={handleNoClick}
        >
          No
        </button>
      </div>

      <div className="additional-details-view__footer">
        (Clicking <strong>Yes</strong> will qualify this student for extra review of their assessments)
      </div>
    </div>
  )
} 